/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Pricelastdiscount3Inputs */

const id_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Terakhir:`)
};

const ms_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskaun Terakhir:`)
};

const da_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidste Rabat:`)
};

const de_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Rabatt:`)
};

const en_us2_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Discount:`)
};

const es_es2_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último descuento:`)
};

const es_mx2_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último descuento:`)
};

const fil_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling Diskwento:`)
};

const fr_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière réduction :`)
};

const it_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo sconto:`)
};

const hu_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó kedvezmény:`)
};

const nl_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste korting:`)
};

const no_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste rabatt:`)
};

const pl_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia promocja:`)
};

const pt_br2_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último desconto:`)
};

const pt_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último desconto:`)
};

const ro_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima reducere:`)
};

const fi_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisin alennus:`)
};

const sv_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste rabatt:`)
};

const vi_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá lần cuối:`)
};

const tr_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son İndirim:`)
};

const cs_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední sleva:`)
};

const bg_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна отстъпка:`)
};

const ru_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последняя скидка:`)
};

const uk_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остання знижка:`)
};

const ar_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر خصم:`)
};

const hi_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम छूट:`)
};

const th_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนลดล่าสุด:`)
};

const ja_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終割引：`)
};

const zh_cn2_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上次折扣:`)
};

const zh_hant1_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上次折扣：`)
};

const ko_offerdetail_overview_pricelastdiscount3 = /** @type {(inputs: Offerdetail_Overview_Pricelastdiscount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 할인:`)
};

/**
* | output |
* | --- |
* | "Last Discount:" |
*
* @param {Offerdetail_Overview_Pricelastdiscount3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_pricelastdiscount3 = /** @type {((inputs?: Offerdetail_Overview_Pricelastdiscount3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Pricelastdiscount3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "ms") return ms_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "da") return da_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "de") return de_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "fil") return fil_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "fr") return fr_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "it") return it_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "hu") return hu_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "nl") return nl_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "no") return no_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "pl") return pl_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "pt") return pt_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "ro") return ro_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "fi") return fi_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "sv") return sv_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "vi") return vi_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "tr") return tr_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "cs") return cs_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "bg") return bg_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "ru") return ru_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "uk") return uk_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "ar") return ar_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "hi") return hi_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "th") return th_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "ja") return ja_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_pricelastdiscount3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_pricelastdiscount3(inputs)
	return ko_offerdetail_overview_pricelastdiscount3(inputs)
});
export { offerdetail_overview_pricelastdiscount3 as "offerDetail.overview.priceLastDiscount" }